import React from "react";
export default function TabView(props) {
    return (
        <div className="flex flex-col gap-8 w-full">
            <div className="overflow-x-auto w-full bg-white border-b-2 border-gray-200">
                <div className="flex flex-row min-w-max">
                    {props.list?.map((val, idx) => {
                        return <div
                            key={idx}
                            className={`px-4 py-3 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors border-b-2 ${val['key'] === props.value ? 'text-black border-transparent' : 'border-transparent text-gray-500 hover:text-gray-700'}`}
                            onClick={() => props.select(val['key'])}
                        >
                            {val['value']}
                        </div>
                    })}
                </div>
            </div>
        </div>
    )
}